import { useState } from 'react';

import type { ReviewsCarouselItemProps } from '../reviewsData';
import { ReviewsCarouselItem } from '../ReviewsCarouselItem';

import { MultipleItemsSlideshow } from '../../MultipleItemsSlideshow';

import styles from './DesktopReviewsCarousel.module.css';
import { useViewport } from '@farmersdog/corgi-x';

const INITIAL_ACTIVE_ITEM = 0;
interface DesktopReviewsCarouselProps {
  items: ReviewsCarouselItemProps[];
}

export const DesktopReviewsCarousel = ({
  items,
}: DesktopReviewsCarouselProps) => {
  const [activeItem, setActiveItem] = useState(INITIAL_ACTIVE_ITEM);

  const safeActiveItem = Math.max(0, Math.min(activeItem, items.length - 1));

  const handleSlideChange = (index: number) => {
    setActiveItem(index);
  };

  const { xl: isXlViewport, lg: isLgViewport } = useViewport();

  return (
    <div className={styles.carousel}>
      <MultipleItemsSlideshow
        withDots
        withButtons
        slidesToShow={isXlViewport ? 4 : isLgViewport ? 3 : 2}
        label="User Testimonials"
        scrollBehavior="smooth"
        className={styles.slideshow}
        activeIndex={safeActiveItem}
        onSlideChange={handleSlideChange}
      >
        {items.map((item, index) => (
          <ReviewsCarouselItem
            key={item.id}
            {...item}
            isActive={index === safeActiveItem}
          />
        ))}
      </MultipleItemsSlideshow>
    </div>
  );
};
